import {Component, Input} from '@angular/core';
import {INotification} from '../../models/notification';
import {
  IQuoteNotificationFailureAction,
  IQuoteNotificationItemErrorEntry,
  IQuoteNotificationItemErrorGuidance,
  QuoteNotificationFailureActionEnum,
} from '../../models/notification-quote-item-error.model';
import {SharedModalUtils} from '../../../../shared/shared-utils/shared-modal/shared-modal.utils';
import {IconsEnum} from '../../../../shared-modules/shared-icons/models/icons.enum';
import {IconColourEnum} from '../../../../shared-modules/shared-icons/models/icons-colour.enum';
import {
  buildQuoteNotificationErrorDescription,
  buildQuoteNotificationItemErrorEntries,
  buildQuoteNotificationItemErrorGuidance,
  isQuoteNotificationFailure,
  resolveQuoteNotificationFailureActions,
  resolveQuoteNotificationItemErrors,
} from '../../utils/notification-quote-error.utils';

/**
 * Displays the detail panel for a QUOTES type notification.
 * Failed quotes show the response message, item errors when present, and action options.
 */
@Component({
  selector: 'app-notification-type-quotes',
  templateUrl: './notification-type-quotes.component.html',
  styleUrls: ['./notification-type-quotes.component.scss'],
  standalone: false,
})
export class NotificationTypeQuotesComponent {
  notification: INotification;

  protected readonly icons = IconsEnum;
  protected readonly iconColourEnum = IconColourEnum;
  protected readonly quoteFailureActions = QuoteNotificationFailureActionEnum;

  constructor(
    private readonly sharedModalUtils: SharedModalUtils,
  ) {
  }

  protected get showErrorPanel(): boolean {
    return isQuoteNotificationFailure(this.notification);
  }

  protected get failingItems(): IQuoteNotificationItemErrorEntry[] {
    return buildQuoteNotificationItemErrorEntries(
      resolveQuoteNotificationItemErrors(this.notification),
    );
  }

  protected get itemErrorGuidance(): IQuoteNotificationItemErrorGuidance[] {
    return buildQuoteNotificationItemErrorGuidance(this.failingItems);
  }

  protected get failureActions(): IQuoteNotificationFailureAction[] {
    return resolveQuoteNotificationFailureActions(this.notification);
  }

  @Input() set setNotification(notification: INotification) {
    this.notification = notification;
  }

  /**
   * Handles a failure-panel action click.
   */
  protected onFailureActionClick(action: QuoteNotificationFailureActionEnum): void {
    switch (action) {
      case QuoteNotificationFailureActionEnum.viewError:
        void this.onViewErrorClick();
        break;
      default:
        break;
    }
  }

  /**
   * Opens a modal with the full quote failure message and item errors.
   */
  private async onViewErrorClick(): Promise<void> {
    await this.sharedModalUtils.createModal({
      modalTitle: 'Quote Error',
      modalTitleIcon: IconsEnum.alertBox,
      modalTitleIconColor: IconColourEnum.red,
      contextDescription: buildQuoteNotificationErrorDescription(this.notification),
      buttonAccept: false,
      buttonAcceptText: '',
      buttonClose: true,
      buttonCloseCross: false,
      buttonCloseText: 'Close',
      cssClass: ['shared-basic-modal-css-medium'],
    });
  }
}
